import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d4762fea"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "clearfix loginContainer"
};
const _hoisted_2 = {
  class: "profile"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://goby-assets.oss-cn-beijing.aliyuncs.com/static_front/img/Avatar.svg",
  alt: "",
  class: "proLeft"
}, null, -1));

const _hoisted_4 = {
  class: "proRight"
};
const _hoisted_5 = {
  class: "proRightI"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icongmail-"
}, null, -1));

const _hoisted_7 = {
  id: "email"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icontime-"
}, null, -1));

const _hoisted_9 = {
  class: "proKey"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "proKLeft"
}, "API KEY", -1));

const _hoisted_11 = {
  class: "proKCenter"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "error_info",
  style: {
    "color": "#F00"
  }
}, null, -1));

const _hoisted_13 = {
  class: "proFooterBtn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, _toDisplayString(_ctx.userInfo.username), 1), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userInfo.email), 1), _hoisted_8, _createElementVNode("span", null, "Joined " + _toDisplayString(_ctx.userInfo.created_at), 1)])])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.userInfo.key), 1), _createElementVNode("span", {
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => _ctx.updateKeyFn && _ctx.updateKeyFn(...args)),
    class: "proKRight refreshkey"
  }, _toDisplayString(_ctx.$t("Refresh Key")), 1), _createElementVNode("span", {
    class: "proKRight",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    (...args) => _ctx.copyKeyFn && _ctx.copyKeyFn(...args))
  }, _toDisplayString(_ctx.$t("Copy Key")), 1), _hoisted_12]), _createVNode(_component_router_link, {
    to: "/modify"
  }, {
    default: _withCtx(() => [_createElementVNode("button", _hoisted_13, _toDisplayString(_ctx.$t("Edit profile")), 1)]),
    _: 1
  }), _ctx.userInfo.status == 0 ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    onClick: _cache[2] || (_cache[2] = //@ts-ignore
    (...args) => _ctx.verifyEmail && _ctx.verifyEmail(...args)),
    class: "proFooterBtn",
    id: "check_email"
  }, "Verify email")) : _createCommentVNode("", true)])]);
}